import request from "@/utils/request";

function getTopicSlug(params = {}) {
  return params.slug || params.week;
}

export function fetchTopic(params) {
  return request.get(`/api/topic/get?slug=${getTopicSlug(params)}`);
}

export function fetchEvent(params, submenu, bool) {
  const slug = getTopicSlug(params);
  if (bool) {
    return request.get(
      `/api/topic/event?slug=${slug}&type=${submenu}&isHome=1`
    );
  } else {
    return request.get(`/api/topic/event?slug=${slug}&type=${submenu}`);
  }
}

export function fetchRead(params) {
  return request.get(`/api/topic/event?slug=${getTopicSlug(params)}&type=read_city`);
}

export function fetchReadPlace(params) {
  return request.get(`/api/topic/event?slug=${getTopicSlug(params)}&type=read_place`);
}

export function fetchNews(params) {
  return request.get(`/api/topic/news?slug=${getTopicSlug(params)}`);
}

export function fetchReadDetail({ event, ...params }) {
  return request.get(`/api/topic/event_detail?slug=${getTopicSlug(params)}&event=${event}`);
}
